import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { Ref } from 'vue'

/**
 * Types
 */
type AuthErrorStore = {
  errorMessage: Ref<string>
  setErrorMessage: (errorMessage: string) => void
}

/**
 * Composable
 */
export const useAuthErrorStore = defineStore<'authError', AuthErrorStore>(
  'authError',
  () => {
    const errorMessage = ref('')
    const setErrorMessage = (_errorMessage: string) => {
      errorMessage.value = _errorMessage
    }

    return {
      errorMessage,
      setErrorMessage,
    }
  },
)
